import { KYMW7401Component } from './kymw7401.component';

import type { CandidateGoodsInfo } from './vo/goods-info.model';

/** 「忘れず注文商品登録」ID */
export const PAGE_KYMW7402 = 'kymw/7402';

/**
 * 忘れず注文商品対象選択 コンポーネントの値を管理するクラス
 *
 * @export KYMW7401Model
 * @class KYMW7401Model
 */
export class KYMW7401Model {
  kymw1108Component: KYMW7401Component;

  candidateGoodsList = [] as CandidateGoodsInfo[];
}
